import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface INameModifierGroupInput {
	changeNameOfModifierGroup: (value: string) => void;
}

const NameModifierGroupInput: React.FC<INameModifierGroupInput> = ({ changeNameOfModifierGroup }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterModifierGroupName') }], [t]);

	return (
		<FormInput
			testId="NameModifierGroupInput"
			name="nameOfModifierGroup"
			label="nameOfModifierGroupLabel"
			onChange={changeNameOfModifierGroup}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
};

export default React.memo(NameModifierGroupInput);
